<template>
  <v-col
    md="5"
    :lg="setColAspect()"
    class="ma-0 pa-0"
    :class="
      is_mobile
        ? 'cart_mobile mobile_height'
        : 'desktop-height d-flex flex-column border-left'
    "
  >
    <v-row v-if="order" no-gutters>
      <v-col cols="12">
        <v-chip-group
          v-model="orderType"
          mandatory
          @change="changeOrderType"
          class="orderType px-3 py-3"
          active-class="orderType__activa"
        >
          <v-chip
            value="is_direct"
            :title="$t('in_direct')"
            :disabled="order && order.from_seller"
          >
            <v-icon left small>mdi-cash-register</v-icon>{{ $t("in_direct") }}
          </v-chip>
          <v-chip
            value="is_on_table"
            :title="$t('in_table')"
            v-if="$store.getters.getGeneralValue('gen_sales_manage_tables')"
          >
            <v-icon left small>mdi-table-furniture</v-icon>{{ $t("in_table") }}
          </v-chip>
          <v-chip
            value="is_domicile"
            :title="$t('delivery')"
            :disabled="order && order.from_seller"
          >
            <v-icon left small>mdi-moped</v-icon>{{ $t("delivery") }}
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>

    <v-divider />

    <v-row v-if="order" class="mt-0 resumen-caja" ref="optionsOrder" no-gutters>
      <v-col cols="12" class="px-3 pt-3" v-if="order.getIsOnTable()">
        <div class="mesa-fila" :class="order.getNameTable() ? 'mesa-fila--lista' : 'mesa-fila--falta'" @click="modalTables = true">
          <v-icon left :color="order.getNameTable() ? 'success' : 'white'">mdi-table-furniture</v-icon>
          <span class="mesa-fila__texto">{{ order.getNameTable() || $t("select_table") }}</span>
          <v-icon v-if="order.getNameTable()" color="grey darken-1" @click.stop="setTableNull()">mdi-close</v-icon>
          <v-icon v-else color="white">mdi-chevron-right</v-icon>
        </div>
      </v-col>
      <v-col cols="12" class="px-3 pt-3" v-if="order.is_domicile">
        <div class="mesa-fila entrega-fila" :class="datosDeEntrega() ? 'mesa-fila--lista' : 'mesa-fila--falta'" @click="modalCustomer = true">
          <v-icon left :color="datosDeEntrega() ? 'success' : 'white'">mdi-map-marker-outline</v-icon>
          <span class="mesa-fila__texto entrega-fila__texto">
            <template v-if="datosDeEntrega()">
              <strong>{{ datosDeEntrega().nombre }}</strong>
              <small>{{ datosDeEntrega().detalle }}</small>
            </template>
            <template v-else>Datos de entrega</template>
          </span>
          <v-icon v-if="datosDeEntrega()" color="grey darken-1">mdi-pencil-outline</v-icon>
          <v-icon v-else color="white">mdi-chevron-right</v-icon>
        </div>
      </v-col>
      <v-col cols="12" class="px-3 py-2 fila-chips">
        <v-chip small outlined color="primary" v-if="!order.data_customer" @click="modalCustomer = true">
          <v-icon left small>mdi-account-search-outline</v-icon>{{ $t("no_client") }}
        </v-chip>
        <v-chip small color="primary" v-else @click="modalCustomer = true">
          <v-icon left small>mdi-account-outline</v-icon>{{ order.getCustomerName() }}
          <v-icon right small @click.stop="removeClient()">mdi-close</v-icon>
        </v-chip>
        <v-chip small :outlined="!order.getNote()" color="primary" @click="noteOrder()">
          <v-icon left small>mdi-comment-text-outline</v-icon>{{ order.getNote() ? "Nota" : "Agregar nota" }}
        </v-chip>
        <v-menu offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-chip small outlined color="grey darken-1" v-bind="attrs" v-on="on">
              <v-icon left small>mdi-dots-horizontal</v-icon>Más
              <v-icon right x-small color="primary" v-if="activeTip || haveCoupon() || activeInvoiceElectronic">mdi-circle</v-icon>
            </v-chip>
          </template>
          <v-list dense>
            <v-list-item @click.stop="activeTip = !activeTip; changeTip()">
              <v-list-item-icon><v-icon>mdi-hand-heart-outline</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>{{ $t("tip") }}</v-list-item-title></v-list-item-content>
              <v-list-item-action><v-switch :input-value="activeTip" dense hide-details readonly></v-switch></v-list-item-action>
            </v-list-item>
            <v-list-item @click="modalCoupon = true" :disabled="!$store.getters.getGeneralValue('gen_sales_activate_coupons') && !haveCoupon()">
              <v-list-item-icon><v-icon>mdi-tag-multiple-outline</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ haveCoupon() ? "Cupón: " + order.getCoupon() : "Cupón de descuento" }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="haveCoupon()">
                <v-icon color="red" @click.stop="$pos.setCoupon($pos.getCurrentOrder(), null)">mdi-close</v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-list-item v-if="$store.getters.getGeneralValue('gen_billing_invoice_electronically') == true"
              @click.stop="activeInvoiceElectronic = !activeInvoiceElectronic; changeInvoiceElectronic()">
              <v-list-item-icon><v-icon>mdi-file-sign</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>{{ $t("pos_invoice_electronic") }}</v-list-item-title></v-list-item-content>
              <v-list-item-action><v-switch :input-value="activeInvoiceElectronic" dense hide-details readonly></v-switch></v-list-item-action>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-col cols="12" class="px-3 pb-3">
        <ng-select-options
          v-model="seller"
          prepend-inner-icon="mdi-account-tie"
          :label="$t('Seller')"
          :items="sellers"
          @change="changeSeller"
          :flat="false"
          :filled="false"
          dense
          :disabled="order && order.from_seller"
          :outlined="true"
          hide-details
        ></ng-select-options>
      </v-col>
            <v-col cols="12" class="px-3 pb-3" v-if="order.getIsDomicile()">
              <v-row>
                <v-col sm="6" lg="6">
                  <ng-number-keyboard
                    prepend-inner-icon="mdi-cash-plus"
                    v-model="price_delivery"
                    :label="$t('price_delivery')"
                    @input="changePriceDelivery"
                    :flat="false"
                    :filled="false"
                    dense
                    :outlined="true"
                    hide-details
                    class="mb-3"
                  ></ng-number-keyboard
                ></v-col>
                <v-col sm="6" lg="6">
                  <ng-select-options
                    v-model="domiciliary"
                    prepend-inner-icon="mdi-moped"
                    :label="$t('Domiciliary')"
                    :items="domiciliaries"
                    @change="changeDomiciliary"
                    :flat="false"
                    :filled="false"
                    dense
                    :outlined="true"
                    hide-details
                  ></ng-select-options
                ></v-col>
              </v-row>
            </v-col>
      <v-col cols="12" class="px-3 pb-2 acciones-pedido">
        <span class="acciones-pedido__cuenta" :title="$t('total_items_current_order')" style="min-width: 28px">
          <v-icon small color="grey darken-1">mdi-basket-outline</v-icon>
          {{ productosDelPedido() }}
        </span>
        <v-spacer></v-spacer>
        <v-btn small outlined color="primary" class="acciones-pedido__btn" :disabled="$pos.getCurrentOrder().isEmpty()"
          @click="printScreen()" title="Imprime la cuenta y deja el pedido guardado en Órdenes pendientes">
          <v-icon left small>mdi-printer-outline</v-icon>Cuenta
        </v-btn>
        <v-btn small outlined color="primary" class="acciones-pedido__btn" v-if="activePrintRemote" :disabled="$pos.getCurrentOrder().isEmpty()"
          @click="printRemote()" :title="$t('print_remote')">
          <v-icon left small>mdi-chef-hat</v-icon>Comanda
        </v-btn>
        <v-btn small text color="error" class="acciones-pedido__anular" :disabled="$pos.getCurrentOrder().isEmpty()"
          @click="openAnnulOrder()" title="Anular el pedido (pide un motivo)">
          <v-icon left small>mdi-close-circle-outline</v-icon>Anular
        </v-btn>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <div
      v-if="order"
      :style="getHeight()"
      class="white pa-0 ma-0"
      :class="is_mobile ? 'overflow-scroll' : ''"
      :key="$store.getters.orderChanged"
    >
      <v-list shaped class="transparent ma-0 pa-0">
        <v-list-item
          v-for="item in order.data_items"
          :key="item.id"
          class="cart-item px-2"
        >
          <CartSectionItem
            :item="item"
            @delete:item="deleteItem"
            @edit:item="$emit('edit:item', $event)"
            @prescription:item="$emit('prescription:item', $event)"
            @selectedOptions="$emit('selectedOptions', $event)"
          >

          </CartSectionItem>
          <!-- <v-divider></v-divider> -->
        </v-list-item>
        <!--{{order.data_items}}-->
      </v-list>
    </div>

    <v-divider />
    <div v-if="order" class="resumen-pago grey lighten-5" ref="totalsSection" id="totals_section">
      <div class="resumen-pago__celda">
        <span>{{ $t("taxes") }}</span>
        <strong>{{ $filters.currency($pos.getCurrentOrder().getTotalTaxes(), 0) }}</strong>
      </div>
      <template v-if="$pos.getCurrentOrder().getPriceTip() > 0 || $pos.getCurrentOrder().getPriceDomicile() > 0">
        <div class="resumen-pago__celda">
          <span>{{ $t("subtotal") }}</span>
          <strong>{{ $filters.currency($pos.getCurrentOrder().getTotalToPay(), 0) }}</strong>
        </div>
        <div class="resumen-pago__celda" :key="'tip_' + $store.getters.orderChanged" v-if="$pos.getCurrentOrder().getPriceTip() > 0">
          <span>{{ $t("tip") }}</span>
          <v-chip x-small color="green lighten-4" class="black--text font-weight-bold" @click="modalTip = true">
            {{ $filters.currency($pos.getCurrentOrder().getPriceTip(), 0) }}
            <v-icon x-small right>mdi-pencil</v-icon>
          </v-chip>
        </div>
        <div class="resumen-pago__celda" v-if="$pos.getCurrentOrder().getPriceDomicile() > 0">
          <span>{{ $t("delivery") }}</span>
          <strong>{{ $filters.currency($pos.getCurrentOrder().getPriceDomicile(), 0) }}</strong>
        </div>
      </template>
    </div>
    <v-row class="pa-0 ma-0" id="cart_options">
      <v-col class="pa-0 ma-0 d-flex flex-row">
        <v-btn
          tile
          depressed
          color="primary"
          x-large
          class="px-5"
          @click="save()"
          :disabled="$pos.getCurrentOrder().isEmpty()"
        >
          <v-icon left>mdi-content-save-outline</v-icon>
          <span class="guardar-texto">{{ $t("save") }}</span>
        </v-btn>
        <v-btn
          class="flex-grow-1 d-flex justify-space-between white--text font-weight-bold"
          id="btn-cobrar"
          @click="pay"
          color="green"
          depressed
          tile
          x-large
          :disabled="
            $pos.getCurrentOrder().isEmpty() ||
            !$pos.getCurrentOrder().isValidForSaleMedicaments() ||
            !allowedPayment()
          "
        >
          <div class="d-flex align-center">
            <v-icon class="me-1 pagar-icono">mdi-cash</v-icon>
            <span>{{ $t("to_pay") }}</span>
          </div>
          <div>
            <span class="pagar-total" :class="claseDelTotal()">{{ textoDelTotal() }}</span>
          </div>
        </v-btn>
        <!-- <v-btn class="white--text" color="green" depressed tile block x-large @click="pay"
          :disabled="$pos.getCurrentOrder().isEmpty() || !allowedPayment()">
          <v-icon left>mdi-cash</v-icon>
          {{ $t("to_pay") }} {{
            $filters.currency(
              $pos.getCurrentOrder().getPriceTotalWithAdds(),
              0
            )
          }}</v-btn>
      </v-col>
      <v-col class="pa-0 ma-0">
        <v-btn class="white--text" color="primary" depressed tile @click="save()"
          :disabled="$pos.getCurrentOrder().isEmpty()">
          <v-icon left>mdi-content-save</v-icon>
          {{ $t("save") }}</v-btn> -->
      </v-col>
    </v-row>
    <CartCustomer
      :dialog="modalCustomer"
      @cancel="modalCustomer = false"
      @selected="selectedCustomer"
    >
    </CartCustomer>
    <CartPayments
      :dialog="modalPayments"
      @cancel="cancelPayment"
      @cancelError="cancelErrorPayment"
      :order="$pos.getCurrentOrder()"
      :is_mobile="is_mobile"
    >
    </CartPayments>
    <CartAnnulOrder
      :dialog="anullCurrentOrder"
      :order="$pos.getCurrentOrder()"
      :message="$t('really_cancel_order')"
      @close="anullCurrentOrder = false"
      @annul="annulOrder($event)"
    ></CartAnnulOrder>
    <CartNote
      :dialog="modalNote"
      :order="$pos.getCurrentOrder()"
      @cancel="modalNote = false"
      @close="modalNote = false"
    >
    </CartNote>
    <CartCoupon
      :dialog="modalCoupon"
      :order="$pos.getCurrentOrder()"
      @cancel="modalCoupon = false"
      @close="modalCoupon = false"
    ></CartCoupon>
    <CartTip
      :dialog="modalTip"
      :order="$pos.getCurrentOrder()"
      @cancel="modalTip = false"
      @modalSetAutomaticTip="modalSetAutomaticTip()"
      @close="modalTip = false"
    ></CartTip>

    <CartPrintRemote
      :dialog="modalPrintRemote"
      :order="$pos.getCurrentOrder()"
      @cancel="modalPrintRemote = false"
      @close="modalPrintRemote = false"
    ></CartPrintRemote>

    <div v-if="modalTables">
      <CartTablesRemote
        :dialog="modalTables"
        :order="$pos.getCurrentOrder()"
        @cancel="modalTables = false"
        @close="modalTables = false"
      ></CartTablesRemote>
    </div>

    <ModalTryAgain ref="modalTryAgain" @try-save-order="saveOrderSeller()" />
  </v-col>
</template>




<script>
import CartSectionItem from "./CartSectionItem";
import CartCustomer from "./CartCustomer";
import CartPayments from "./CartPayments";
import CartAnnulOrder from "./CartAnnulOrder";
import CartNote from "./CartNote";
// import CartTablesRemote from "./CartTablesRemote";
import CartCoupon from "./CartCoupon";
import CartTip from "./CartTip";
import CartTablesRemote from "./CartTablesRemote";
import { isStoreActive } from "@/plugins/db-firestore";
import ModalTryAgain from "./ModalTryAgain.vue";
import CartPrintRemote from "./CartPrintRemote.vue";
import MixinConfirm from "../../../mixins/MixinConfirm";
export default {
  name: "CartSection",
  components: {
    CartSectionItem,
    CartCustomer,
    CartPayments,
    CartAnnulOrder,
    CartNote,
    CartPrintRemote,
    CartTablesRemote,
    CartCoupon,
    CartTip,
    ModalTryAgain,
  },
  mixins: [MixinConfirm],
  props: ["is_mobile", "aspect_ratio"],
  data: () => ({
    tab: null,
    orders: null,
    vHeight: 67,
    order: null,
    modalCoupon: false,
    modalCustomer: false,
    modalPayments: false,
    modalNote: false,
    modalPrintRemote: false,
    modalTip: false,
    modalTables: false,
    anullCurrentOrder: false,
    cashRegister: null,
    activePrintRemote: false,
    employees: [],
    sellers: [],
    domiciliaries: [],
    domiciliary: null,
    seller: null,
    price_delivery: null,
    activeTip: false,
    activeInvoiceElectronic: false,
    orderType: "is_on_table",
  }),
  computed: {
    orderTabClasses() {
      return this.$pos.getCurrentOrder().data_customer
        ? "green--text green lighten-5"
        : "grey--text";
    },
    orderTabColor() {
      return this.$pos.getCurrentOrder().data_customer
        ? "green"
        : "grey darken-1";
    },
    tipTabClasses() {
      return this.activeTip ? "green--text green lighten-5" : "grey--text";
    },
    tipTabColor() {
      return this.activeTip ? "green" : "grey darken-1";
    },
    couponTabClasses() {
      return this.$store.getters.getGeneralValue(
        "gen_sales_activate_coupons"
      ) && this.haveCoupon()
        ? "green--text green lighten-5"
        : "grey--text";
    },
    couponTabColor() {
      return this.$store.getters.getGeneralValue(
        "gen_sales_activate_coupons"
      ) && this.haveCoupon()
        ? "green"
        : "grey darken-1";
    },
    invoiceTabClasses() {
      return this.activeInvoiceElectronic
        ? "green--text green lighten-5"
        : "grey--text";
    },
    invoiceTabColor() {
      return this.activeInvoiceElectronic ? "green" : "grey darken-1";
    },
  },
  watch: {
    "$store.getters.orderChanged": function () {
      //this.order = this.$pos.getCurrentOrder();
      //console.log("order changed .................................");
      this.$set(this, "order", this.$pos.getCurrentOrder());
      this.setDefaultsOnChargeOrder();
    },
    "$store.getters.turn"(val) {
      if (!this.order) {
        this.order = this.$pos.getCurrentOrder();
      }
      if (this.order.is_open == false) {
        this.createNewOrder();
        this.order = this.$pos.getCurrentOrder();
      }
    },
  },
  //props: ['order'],
  mounted() {
    this.order = this.$pos.getCurrentOrder();

    setTimeout(async () => {
      this.setDefaultsOnChargeOrder();
      this.getEmployees();
      await this.setCashRegister();

      /* */
    }, 200);
  },
  methods: {
    getPendingOrder(id) {
      this.$http.get("api/v1/orders-pending", { id: id }).then((response) => {
        //this.orders = response.items;
        this.$db.updateOrders(response.items);
      });
    },
    textoDelTotal() {
      return this.$filters.currency(this.$pos.getCurrentOrder().getPriceTotalWithAdds(), 0);
    },
    // El total se achica con las cifras para no pisar la palabra «Pagar» (cabe hasta miles de millones).
    claseDelTotal() {
      const n = this.textoDelTotal().length;
      return n >= 14 ? "pagar-total--xs" : n >= 12 ? "pagar-total--s" : "";
    },
    // A quién y a dónde se entrega: el cliente del pedido con celular y dirección (sin eso no se puede cobrar un domicilio).
    datosDeEntrega() {
      const c = this.order && this.order.data_customer;
      if (!c || !c.first_name || !c.phone || !c.address) {
        return null;
      }
      return { nombre: this.order.getCustomerName(), detalle: c.address + " · " + c.phone };
    },
    productosDelPedido() {
      return Math.ceil(this.$pos.getCurrentOrder().getTotalItems());
    },
    allowedPayment() {
      let order = this.$pos.getCurrentOrder();
      if (order.is_electronic_invoice) {
        if (!order.data_customer) {
          return false;
        }
      }
      return true;
    },
    setTableNull() {
      this.$pos.setNameTable(this.order, null);
      this.$pos.setIsOnTable(this.order, false);
    },
    activateCoupons() {
      return true;
    },
    activateDomicilies() {
      return false;
    },
    pay() {
      if (this.order.getIsOnTable() && !this.order.getNameTable()) {
        this.modalTables = true;
        return;
      }
      if (this.order.is_domicile) {
        if (
          !this.order.data_customer ||
          !this.order.data_customer["first_name"] ||
          !this.order.data_customer["phone"] ||
          !this.order.data_customer["address"]
        ) {
          this.modalCustomer = true;
          return;
        }
      }
      this.modalPayments = true;
    },
    annulOrder(order) {
      this.anullCurrentOrder = false;
      this.createNewOrder();
    },
    async setCashRegister() {
      let installation = this.$store.getters.installation;
      if (installation && !this.cashRegister) {
        this.cashRegister = await this.$db.getCashRegister(
          installation.cash_id
        );
      }
      this.getValueActivePrintRemote();
    },
    getValueActivePrintRemote() {
      this.activePrintRemote = false;
      if (this.cashRegister) {
        if (this.cashRegister.config) {
          if (
            typeof this.cashRegister.config.pos_active_print_remote == "boolean"
          ) {
            this.activePrintRemote =
              this.cashRegister.config.pos_active_print_remote;
          }
        }
      }
    },
    haveCoupon() {
      if (this.order.getCoupon()) {
        return true;
      }
      return false;
    },
    cancelPayment(params) {
      if (params) {
        if (params.orderfinalized) {
          this.createNewOrder();
          this.activeTip = false;
          this.activeInvoiceElectronic = false;
        } else if (!this.tieneCuentasSeparadas()) {
          this.$pos.deleteAllPayments();
        }
      }
      this.modalPayments = false;
    },
    cancelErrorPayment() {
      if (!this.tieneCuentasSeparadas()) {
        this.$pos.deleteAllPayments();
      }
      this.modalPayments = false;
    },
    // Lo cobrado con «Separar cuenta» ya se le cobró a cada cliente: cerrar el cobro o un error del servidor no lo
    // devuelven a «Por pagar» (se podía cobrar dos veces la misma cuenta). Esos pagos se quitan uno por uno, en la lista.
    tieneCuentasSeparadas() {
      const order = this.$pos.getCurrentOrder();
      return !!order && (order.getPayments() || []).some((p) => Array.isArray(p.lineas) && p.lineas.length > 0);
    },
    openAnnulOrder() {
      this.anullCurrentOrder = true;
    },
    changeOrderType(type) {
      //ver orden en que estan los botones en el v-btn-toggle
      if (this.orderType == "is_direct") {
        //en_tienda
        this.setVHeight();
        this.$pos.setIsDomicile(this.order, false);
        this.$pos.setIsOnTable(this.order, false);
        this.$pos.setNameTable(this.order, null);
        this.$pos.setStorePickup(this.order, true);
        this.$pos.setPriceDomicile(this.order, 0);
        this.$pos.setDomiciliary(null);
      }
      if (this.orderType == "is_on_table") {
        this.setVHeight();
        // this.modalTables = true;
        this.$pos.setIsOnTable(this.order, true);
        this.$pos.setIsDomicile(this.order, false);
        this.$pos.setStorePickup(this.order, false);
        this.$pos.setPriceDomicile(this.order, 0);
        this.$pos.setDomiciliary(null);
      }
      if (this.orderType == "is_domicile") {
        //domicilios
        this.setVHeight();
        this.$pos.setIsDomicile(this.order, true);
        this.$pos.setIsOnTable(this.order, false);
        this.$pos.setNameTable(this.order, null);
        this.$pos.setStorePickup(this.order, false);
      }
    },
    electronicInvoiceHint() {
      return this.$t("invoice_electronic");
    },
    async saveOrderSeller() {
      // naren
      // validar con isStoreActive si la tienda esta activa
      // si no esta activa le salga una modal indicando que el pos no esta recibiendo las ordenes
      // y un boton de actualizar
      let installation = this.$store.getters.installation;
      //descomentar si es necesario
      /* let active = await isStoreActive(installation.subsidiary_id, 1);
      if (!active) {
        this.$refs.modalTryAgain.renderItem();
        return;
      }*/
      this.$pos.setOrderStatus(this.$pos.getCurrentOrder(), "pending");
      let name_table = this.$pos.getCurrentOrder().getNameTable();
      if (name_table) {
        let table = await this.$db.getTableByName(name_table);
        await this.$db.updateTableBusy(table, true);
      } else {
        this.modalTables = true;
        //alert('Debe seleccionar una mesa')
        return;
      }

      // naren en el api de guardar la orden se debe validar si from_seller es true, en este caso
      // se debe notificar por firebase desde laravel el evento: id de la orden el time, y st=draft
      // y tambien enviar una notificacion push al mesero
      let response = await this.$pos.saveOrderSeller(
        this.$pos.getCurrentOrder(),
        this.$http,
        true
      );

      this.createNewOrder();
    },
    createNewOrder() {
      this.$pos.createOrder();
      this.$store.dispatch("createdOrder");
    },
    async save() {
      if (
        this.$pos.getCurrentOrder().getIsOnTable() &&
        !this.$pos.getCurrentOrder().getNameTable()
      ) {
        this.modalTables = true;
        return;
      }
      this.$pos.setOrderStatus(this.$pos.getCurrentOrder(), "received");
      if (this.$pos.getCurrentOrder().getIsOnTable()) {
        let name_table = this.$pos.getCurrentOrder().getNameTable();
        if (name_table) {
          let table = await this.$db.getTableByName(name_table);
          await this.$db.updateTableBusy(table, true);
        }
      }
      const res = await this.$pos.saveOrder(
        this.$pos.getCurrentOrder(),
        this.$http
      );
      if (res.code == 9780) {
        let message =
          "Esta orden ya fue pagada anteriormente con el consecutivo " +
          res.consecutive +
          ", por favor verificala antes de volver a facturar, si deseas procesarla presiona confirmar";
        const confirm = await this.openConfirm(message);
        if (confirm) {
          this.$pos.getCurrentOrder().id = null;
          this.$pos.getCurrentOrder().data_order_trace = [
            { pre_order: res.consecutive },
          ];
          this.$pos.getCurrentOrder().local_reference = this.$pos
            .getCurrentOrder()
            .createReference();
        } else {
          this.$pos.createOrder();
          this.$store.dispatch("createdOrder");
        }
      }
      if (res.success) {
        this.createNewOrder();
      }
    },
    selectedCustomer(customer) {
      this.$pos.setCustomer(customer);
      this.modalCustomer = false;
    },
    deleteItem(itemLine) {
      //si la orden ya se imprimio debe escribir un motivo, se guarda el motivo en la orden
      this.$pos.deleteItem(itemLine);
      this.$pos.setPriceTip(this.$pos.getCurrentOrder(), null);
    },
    removeClient() {
      this.$pos.setCustomer(null);
      this.modalCustomer = false;
    },
    noteOrder() {
      this.modalNote = true;
    },
    openModalCoupon() {
      this.modalCoupon = true;
    },
    openModalTables() {
      this.modalTables = true;
    },
    openModalTip() {
      this.modalTip = true;
    },
    changeSeller(evt) {
      this.$pos.setSeller(evt);
    },
    changeDomiciliary(evt) {
      this.$pos.setDomiciliary(evt);
    },
    changePriceDelivery(evt) {
      if (evt) {
        this.$pos.setPriceDomicile(this.order, parseInt(evt));
      } else {
        this.$pos.setPriceDomicile(this.order, 0);
      }
    },
    changeInvoiceElectronic() {
      if (this.activeInvoiceElectronic) {
        let order = this.$pos.getCurrentOrder();
        if (!order.data_customer) {
          this.modalCustomer = true;
        }
      }

      this.$pos.setIsElectronicInvoice(
        this.order,
        this.activeInvoiceElectronic
      );
    },
    changeTip() {
      this.$pos.setActiveTip(this.$pos.getCurrentOrder(), this.activeTip);
      if (this.activeTip) {
        this.$pos.setPriceTip(this.order, null);
      } else {
        this.$pos.setPriceTip(this.order, 0);
      }
      this.setVHeight();
    },
    printRemote() {
      this.modalPrintRemote = true;
    },
    async printScreen() {
      // La cuenta no es un envío a cocina: el pedido queda abierto («pending») y, si ya estaba en cocina, sigue ahí.
      const estado = this.$pos.getCurrentOrder().order_status;
      if (!["received", "preparing", "prepared", "returned"].includes(estado)) {
        this.$pos.setOrderStatus(this.$pos.getCurrentOrder(), "pending");
      }
      const res = await this.$pos.saveOrder(
        this.$pos.getCurrentOrder(),
        this.$http
      );
      if (res.code == 9780) {
        let message =
          "Esta orden ya fue pagada anteriormente con el consecutivo " +
          res.consecutive +
          ", por favor verificala antes de volver a facturar, si deseas procesarla presiona confirmar";
        const confirm = await this.openConfirm(message);
        if (confirm) {
          this.$pos.getCurrentOrder().id = null;
          this.$pos.getCurrentOrder().data_order_trace = [
            { pre_order: res.consecutive },
          ];
          this.$pos.getCurrentOrder().local_reference = this.$pos
            .getCurrentOrder()
            .createReference();
        } else {
          this.createNewOrder();
        }
      }
      if (res.success) {
        await this.$pos.printReceiptScreen(this.order);
        this.$store.commit(
          "setMessage",
          "La orden se guardó, revisala en ordenes pendientes."
        );
        this.createNewOrder();
      }
    },
    setColorNote() {
      if (this.order.getNote()) {
        return "primary";
      }
    },
    setDefaultsOnChargeOrder() {
      if (this.order.getIsOnTable()) {
        this.orderType = "is_on_table";
      } else if (this.order.getIsDomicile()) {
        this.orderType = "is_domicile";
      } else {
        this.orderType = "is_direct";
      }

      if (this.order.getPriceTip() > 0) {
        this.activeTip = true;
      }

      if (this.order.getIsElectronicInvoice()) {
        this.activeInvoiceElectronic = true;
      }

      if (this.order.getBusPersonDomiciliaryId()) {
        this.domiciliary = this.order.getDataDomiciliary();
      } else {
        this.domiciliary = null;
      }

      if (this.order.getBusPersonSellerId()) {
        this.seller = this.order.getDataSeller();
      } else {
        this.seller = null;
      }

      if (this.order.getPriceDomicile() && this.order.getPriceDomicile() > 0) {
        this.price_delivery = this.order.getPriceDomicile();
      } else {
        this.price_delivery = null;
      }
      this.setVHeight();
    },
    getHeight() {
      let th = 58;
      if (this.is_mobile) {
        // return "";
        // th = 15;
      }
      if (this.$refs.optionsOrder) {
        th += this.$refs.optionsOrder.clientHeight;
        th += this.$refs.totalsSection.clientHeight;
        return "overflow-y:auto;height: calc(100vh - " + th + "px);";
      } else {
        return "overflow-y:auto;height: 25vh;";
      }
    },
    setVHeight() {},
    async getEmployees() {
      const sellers = await this.$db.getEmployeesByType("seller");
      this.sellers = sellers;
      const domiciliaries = await this.$db.getEmployeesByType("deliverer");
      this.domiciliaries = domiciliaries;
    },
    modalSetAutomaticTip($event) {},
    setColspanMobile(value) {
      if (this.is_mobile) {
        return value;
      }
      return 1;
    },
    setColAspect() {
      const aspect = ["5:4", "4:3", "16:9", "16:10"];
      if (this.aspect_ratio) {
        if (this.aspect_ratio.aspect_ratio) {
          if (this.inArray(this.aspect_ratio.aspect_ratio, aspect)) {
            return 5;
          }
        }
      }
      return 4;
    },
    inArray(needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
.resumen-pago {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px 18px;
  padding: 6px 16px;
}

.resumen-pago__celda {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 22px;
  font-size: 0.82rem;
  color: rgba(0, 0, 0, 0.6);
}

.resumen-pago__celda strong {
  color: rgba(0, 0, 0, 0.87);
}

.pagar-total {
  font-size: 1.25rem;
  font-weight: 800;
  white-space: nowrap;
  margin-left: 12px;
}

.pagar-total--s {
  font-size: 1.05rem;
}

.pagar-total--xs {
  font-size: 0.9rem;
}

#cart_options .v-btn.flex-grow-1 {
  min-width: 0;
}

#cart_options .v-btn.flex-grow-1 .v-btn__content {
  flex: 1 1 auto;
  min-width: 0;
  gap: 8px;
}

/* Columna del carrito angosta: sin el ícono de efectivo para que quepa el total. */
#cart_options {
  container-type: inline-size;
}

@container (max-width: 520px) {
  #cart_options .pagar-icono {
    display: none;
  }
}

@media (max-width: 420px) {
  #cart_options .guardar-texto,
  #cart_options .pagar-icono {
    display: none;
  }
  #cart_options .v-btn.px-5 {
    padding: 0 14px !important;
    min-width: 0;
  }
  .pagar-total {
    font-size: 1.1rem;
  }
}

.resumen-caja {
  flex: 0 0 auto;
  align-content: flex-start;
  background: #fafafa;
}

.mesa-fila {
  display: flex;
  align-items: center;
  min-height: 52px;
  padding: 0 14px;
  border-radius: 12px;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
}

.mesa-fila--falta {
  background: #f57c00;
  color: #fff;
}

.mesa-fila--lista {
  background: #fff;
  border: 2px solid #4caf50;
  color: rgba(0, 0, 0, 0.87);
}

.mesa-fila__texto {
  flex: 1;
}

.entrega-fila {
  padding-top: 6px;
  padding-bottom: 6px;
}

.entrega-fila__texto {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.25;
}

.entrega-fila__texto strong,
.entrega-fila__texto small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.entrega-fila__texto small {
  font-size: 0.8rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
}

.fila-chips {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: none;
}

.fila-chips::-webkit-scrollbar {
  display: none;
}
.mobile_height {
  height: 100vh !important;
}

.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: rgba(0, 0, 0, 0.05) !important;
}

.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  background: none;
}

.v-btn-toggle > .v-btn.v-btn {
  border-style: none;
}

.v-item--active {
  border: none !important;
}

/* Modo de la venta: tres fichas del mismo ancho; siempre hay una elegida. */
.orderType .v-slide-group__content {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  width: 100%;
  padding: 0;
}

.orderType .v-chip {
  flex: 1 1 0;
  justify-content: center;
  height: 40px;
  margin: 0;
  padding: 0 10px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
}

/* El estilo es «scoped»: el contenedor interno del grupo no recibe el atributo, por eso la separación va como margen de las fichas. */
.orderType .v-chip:not(:last-child) {
  margin-right: 12px;
}

.orderType .v-chip.orderType__activa {
  color: #fff !important;
  background: var(--v-primary-base) !important;
}

.orderType .v-chip.orderType__activa .v-icon {
  color: #fff !important;
}

.v-btn:before {
  background-color: #e4e4e4 !important;
}
</style>

<style>
@media only screen and (max-width: 981px) {
  #totals_section {
    bottom: 5ch;
  }

  #cart_options {
    bottom: 0;
    background: #fafafa;
  }

  #totals_section,
  #cart_options {
    position: fixed;
    z-index: 100;
    width: 100%;
  }
}

.desktop-height {
  height: calc(100vh - 70px) !important;
}

.mobile-height {
  height: calc(100vh - 14ch) !important;
}

.cart_options .v-select > .v-input__control > .v-input__slot label {
  color: rgba(0, 0, 0, 1);
  font-size: 0.875rem !important;
}

.cart_options .v-text-field > .v-input__control > .v-input__slot label {
  color: rgba(0, 0, 0, 1);
  font-size: 0.875rem !important;
}

.cart_options .v-input--switch > .v-input__control > .v-input__slot label {
  color: rgba(0, 0, 0, 1);
  font-size: 0.875rem !important;
  font-weight: 400 !important;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}

.cart_coupon_fix span {
  top: -5px;
}

.border-left {
  border-left: 1px solid #e2e4e8;
}
.acciones-pedido {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.acciones-pedido .v-btn.v-size--small {
  padding: 0 10px;
}

.acciones-pedido__cuenta {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
}

.acciones-pedido__btn.v-btn {
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
}

.acciones-pedido__anular.v-btn {
  margin-left: 2px;
  padding-left: 10px !important;
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 0 4px 4px 0;
  letter-spacing: 0;
  text-transform: none;
}
</style>